import type { ReportBlock } from '../types';

/** Coorte inteiramente fictícia: 240 casos = 96 interagiram + 144 sem interação.
 * 24 acordos = 22 com interação + 2 de tratativas anteriores. Nunca são recebimentos. */
export const fixtureBlocks: ReportBlock[] = [
  {
    id: 'overview',
    title: 'O período em perspectiva',
    summary:
      'Uma carteira de exemplo para explorar como a Lex organiza o seu fechamento. Todos os valores desta demonstração são fictícios.',
    metrics: [
      { label: 'Casos trabalhados', value: '240', detail: '180 novos · 60 em andamento' },
      { label: 'Pessoas que interagiram', value: '96', detail: 'Ao menos uma mensagem recebida' },
      {
        label: 'Acordos celebrados',
        value: '24',
        detail: '22 com interação · 2 de tratativas anteriores',
      },
      { label: 'Valor acordado', value: 'R$ 86.400', detail: 'Não representa valor recebido' },
    ],
    notes: [
      'Base ilustrativa: lotes concluídos no período; casos distintos elegíveis. Erros e conflitos técnicos não entram na apresentação ao cliente.',
    ],
  },
  {
    id: 'funnel',
    title: 'Da conversa ao acordo',
    summary:
      '40% dos casos tiveram interação. Entre as 96 pessoas que responderam, 22 fecharam acordo: conversão de 22,9%.',
    bars: [
      { label: 'Casos trabalhados', value: 240, total: 240 },
      { label: 'Com interação', value: 96, total: 240 },
      { label: 'Acordos com interação', value: 22, total: 240 },
    ],
    notes: [
      '144 casos sem interação no período. Dois acordos vieram de tratativas anteriores e não compõem o numerador da conversão sobre interações.',
    ],
  },
  {
    id: 'agreements',
    title: 'Valor construído nas negociações',
    summary:
      'Os 24 acordos representam R$ 86.400 negociados sobre R$ 108.000 de dívida original. Redução ponderada pelo valor: 20%.',
    metrics: [
      { label: 'Dívida original', value: 'R$ 108.000', detail: 'Somente os casos com acordo' },
      {
        label: 'Valor acordado',
        value: 'R$ 86.400',
        detail: 'Recebimentos não disponíveis nesta base',
      },
    ],
    columns: ['Contraparte fictícia', 'Dívida', 'Acordado', 'Redução'],
    rows: [
      ['Empresa Exemplo A', 'R$ 6.000', 'R$ 4.800', '20%'],
      ['Empresa Exemplo B', 'R$ 4.500', 'R$ 3.600', '20%'],
      ['Empresa Exemplo C', 'R$ 3.000', 'R$ 2.400', '20%'],
    ],
    notes: [
      'Amostra ilustrativa de 3 dos 24 acordos. A tabela completa deve ser paginada pelo serviço de relatório.',
    ],
  },
  {
    id: 'objections',
    title: 'O que impede o próximo passo?',
    summary:
      'Motivos ilustrativos dos 36 encerramentos analisados. As categorias somam a base e não são inferidas de um único trecho de conversa.',
    bars: [
      { label: 'Condição de pagamento', value: 14, total: 36 },
      { label: 'Divergência de valor', value: 9, total: 36 },
      { label: 'Solicitou documentos', value: 6, total: 36 },
      { label: 'Sem interesse', value: 4, total: 36 },
      { label: 'Outros motivos', value: 3, total: 36 },
    ],
  },
  {
    id: 'handoffs',
    title: 'IA e pessoas, em continuidade',
    summary:
      'Pedidos de atendimento humano e modo atual são medidas diferentes. Um caso pode solicitar uma pessoa e depois voltar ao agente.',
    metrics: [
      { label: 'Solicitaram uma pessoa', value: '18', detail: 'Casos distintos durante o período' },
      { label: 'Em modo humano agora', value: '12', detail: 'Fotografia no momento da consulta' },
    ],
    notes: [
      'Prioridade sugerida: revisar casos que aguardam continuidade humana antes de iniciar uma nova tentativa automatizada.',
    ],
  },
  {
    id: 'timing',
    title: 'O ritmo da conversão',
    summary:
      'Nos 24 acordos do exemplo, a conversão levou em média 3,2 dias. Mínimo: no mesmo dia. Máximo: 12 dias.',
    columns: ['Tempo até o acordo', 'Acordos'],
    rows: [
      ['No mesmo dia', '8'],
      ['1 a 3 dias', '9'],
      ['4 a 7 dias', '5'],
      ['Mais de 7 dias', '2'],
    ],
    notes: [
      '32 casos tiveram mais de uma tentativa. Repetição é um sinal para investigar; não comprova irritação do cliente.',
    ],
  },
  {
    id: 'actions',
    title: 'Do resultado à próxima decisão',
    summary:
      'Sugestões ilustrativas com base nos indicadores deste exemplo. A decisão permanece com a sua equipe.',
    notes: [
      '01 · Revisar condições de pagamento: é o motivo mais frequente entre os encerramentos do exemplo (14 de 36).',
      '02 · Priorizar os 12 casos que estão em atendimento humano e definir o próximo contato.',
      '03 · Investigar os casos sem interação antes de aumentar a frequência de tentativas.',
    ],
  },
];
